import { FilterContext } from './types';
import { defaultColleagueFiltersRange, defaultResourceFiltersRange } from './common';
import { now, toISO } from '@jooxter/utils';

export const defaultFilters: FilterContext = {
  from: toISO(now().startOf('week')),
  to: toISO(now().endOf('week')),
  heatmap: {
    resourceTypeIds: [],
    location: {
      floorIds: [],
      locationIds: [],
    },
  },
  resource: {
    date: defaultResourceFiltersRange(),
    now: true,
    labels: [],
    resourceName: '',
    capacity: 1,
    organizerId: null,
    resourceTypesIds: [],
    location: {
      floorIds: [],
      locationIds: [],
    },
    favoritesOnly: false,
  },
  colleague: {
    date: defaultColleagueFiltersRange(),
    locationIds: [],
    groupIds: [],
    globalSearch: '',
    favoritesOnly: false,
    type: null,
  },
  realTime: {
    floorIds: [],
    locationIds: [],
  },
  floorPlan: {
    floorIds: [],
    locationIds: [],
  },
};
